import {Locales} from '@netx/core-next/locales/utils/Locales';
import {AssetProjectReviewField} from './schema';

export const ASSET_PROJECT_ACTION_LABELS = Locales((i18n) => ({
	PROJECT: i18n('i18n.review'),
}));

export const AssetProjectReviewsMessage = Locales((i18n) => ({
	ERROR: i18n('i18n.error'),
	NO_RECORDS: i18n('i18n.noRecords'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),
}));

export const AssetProjectReviewsTitle = Locales((i18n) => ({
	REVIEWS: i18n('i18n.reviews'),
}));

export const AssetProjectReviewsSubTitle = Locales((i18n) => ({
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const AssetProjectReviewActionLabel = Locales((i18n) => ({
	CREATE: i18n('i18n.review'),
	VIEW: i18n('i18n.viewReview'),
}));

export const AssetProjectReviewsColumnLabel = Locales((i18n) => ({
	[AssetProjectReviewField.title]: i18n('i18n.title'),
	creationDate: i18n('i18n.creationDate'),
	[AssetProjectReviewField.decision]: i18n('i18n.decision'),
	[AssetProjectReviewField.status]: i18n('i18n.status'),
}));
